module.exports = __webpack_public_path__ + "static/media/DubaiW23-Regular.a710a318.ttf";